export enum RequestState {
  WAITING = 'waiting',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}
